(() => {
  const offerUrl = "https://in-shape.co/products/tanks-buy2get1free?variant=53327865512047";
  const acquisitionKeys = new Set([
    "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id",
    "utm_source_platform", "utm_creative_format", "utm_marketing_tactic",
    "gclid", "dclid", "gbraid", "wbraid", "fbclid", "msclkid", "ttclid", "trybe"
  ]);
  const popupSelector = '[data-testid="POPUP"], [role="dialog"][class*="kl-private-reset-css"], [aria-modal="true"][class*="kl-private-reset-css"], iframe[src*="klaviyo.com"][title*="popup" i], iframe[src*="klaviyo.com"][aria-label*="popup" i]';

  function initialize(root) {
    if (!root || root.dataset.peerStoryInitialized === "true") return;
    root.dataset.peerStoryInitialized = "true";
    const version = root.dataset.storyVersion || "peer-story-v1";
    const seen = new Set();
    let progressScheduled = false;
    let popupScheduled = false;

    function acquisitionDestination() {
      const destination = new URL(offerUrl);
      const source = new URLSearchParams(window.location.search);
      acquisitionKeys.forEach((key) => {
        const value = source.get(key);
        if (!value || value.length > 512 || /[\u0000-\u001f\u007f]/.test(value)) return;
        if (!key.startsWith("utm_") && !/^[A-Za-z0-9._~-]+$/.test(value)) return;
        destination.searchParams.set(key, value);
      });
      return destination.href;
    }

    const destination = acquisitionDestination();
    root.querySelectorAll("a[data-peer-story-offer]").forEach((link) => {
      link.href = destination;
    });

    function analyticsAllowed() {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== "function") return false;
      return privacy.analyticsProcessingAllowed() === true;
    }

    function emit(name, detail, onceKey) {
      if (!analyticsAllowed() || typeof window.gtag !== "function") return false;
      if (onceKey && seen.has(onceKey)) return false;
      window.gtag("event", name, {
        story_version: version,
        ...detail
      });
      if (onceKey) seen.add(onceKey);
      return true;
    }

    function recordProgress() {
      progressScheduled = false;
      if (!root.isConnected || document.visibilityState === "hidden") return;
      emit("advertorial_view", {}, "view");
      const rect = root.getBoundingClientRect();
      if (rect.height <= 0) return;
      const reached = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / rect.height));
      [25, 50, 75, 100].forEach((depth) => {
        if (reached * 100 >= depth) {
          emit("advertorial_read_depth", { read_depth: depth }, `depth-${depth}`);
        }
      });
    }

    function scheduleProgress() {
      if (progressScheduled) return;
      progressScheduled = true;
      window.requestAnimationFrame(recordProgress);
    }

    root.addEventListener("click", (event) => {
      const link = event.target instanceof Element ? event.target.closest("a[data-peer-story-offer]") : null;
      if (!link || !root.contains(link)) return;
      emit("advertorial_cta_click", { cta_location: link.dataset.ctaLocation || "article" });
    });

    function suppressPopups() {
      popupScheduled = false;
      if (!document.body.classList.contains("template-page-inshape-peer-story")) return;
      document.querySelectorAll(popupSelector).forEach((popup) => {
        if (popup.getAttribute("aria-hidden") !== "true") popup.setAttribute("aria-hidden", "true");
        if (!popup.inert) popup.inert = true;
      });
      [document.documentElement, document.body].forEach((node) => {
        if (!node.classList.contains("klaviyo-prevent-body-scrolling")) return;
        node.classList.remove("klaviyo-prevent-body-scrolling");
        if (node.style.overflow === "hidden") node.style.removeProperty("overflow");
      });
    }

    function schedulePopupSuppression() {
      if (popupScheduled) return;
      popupScheduled = true;
      window.requestAnimationFrame(suppressPopups);
    }

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.type === "childList" || mutation.target === document.documentElement || mutation.target === document.body)) {
        schedulePopupSuppression();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "style"] });
    suppressPopups();
    recordProgress();
    window.addEventListener("scroll", scheduleProgress, { passive: true });
    window.addEventListener("resize", scheduleProgress, { passive: true });
    document.addEventListener("visitorConsentCollected", scheduleProgress);
    document.addEventListener("visibilitychange", scheduleProgress);
    window.addEventListener("load", scheduleProgress, { once: true });
    const shopify = window.Shopify;
    if (shopify && !shopify.customerPrivacy && typeof shopify.loadFeatures === "function") {
      shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (errors) => {
        if (!errors) scheduleProgress();
      });
    }
    document.addEventListener("shopify:section:unload", (event) => {
      if (!(event.target instanceof Element) || !event.target.contains(root)) return;
      observer.disconnect();
      window.removeEventListener("scroll", scheduleProgress);
      window.removeEventListener("resize", scheduleProgress);
      document.removeEventListener("visitorConsentCollected", scheduleProgress);
      document.removeEventListener("visibilitychange", scheduleProgress);
    });
  }

  document.querySelectorAll(".ish-peer-story").forEach(initialize);
  document.addEventListener("shopify:section:load", (event) => {
    if (!(event.target instanceof Element)) return;
    event.target.querySelectorAll(".ish-peer-story").forEach(initialize);
  });
})();
